// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9g_7v","icon":"styles_icon__1E6bU"};